async function getZipcodeInformations(event) {
    let cep = {};

    await fetch(`https://viacep.com.br/ws/${event}/json/`)
        .then((res) => res.json())
        .then((data) => {
            cep = data;
        });

    return cep;
}



export async function getStates() {
    let states

    await fetch('https://servicodados.ibge.gov.br/api/v1/localidades/estados/.')
        .then((res) => res.json())
        .then((data) => {
            states = data;
        });
        return states
}


export default getZipcodeInformations;